import type { SlackChannel } from '@baseball-near-you/common';
import type {
  ChatPostMessageArguments,
  ChatPostMessageResponse,
} from '@slack/web-api';
import { AbstractClient } from './AbstractFetchClient';

export class SlackClient extends AbstractClient {
  postMessage = this.payloadHandler<
    ChatPostMessageResponse,
    {
      payload: {
        channel: SlackChannel;
      } & Omit<ChatPostMessageArguments, 'channel'>;
    }
  >('POST', '');
}
